import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { persistStore } from "redux-persist";
// import { PersistGate } from "redux-persist/integration/react"; // needed to persist redux store properly
import App from "./App";
import { FormProvider } from "./components/common/FormContext";
import "./index.css";
import { store } from "./ReduxStore/Store";
import reportWebVitals from "./reportWebVitals";
import { HelmetProvider } from "react-helmet-async";

const persistor = persistStore(store);

const rootElement = document.getElementById("root");

const app = (
  <React.StrictMode>
    <Provider store={store} persistor={persistor}>
      {/* <PersistGate loading={null} persistor={persistor}> */}
        <BrowserRouter>
          <FormProvider>
            <HelmetProvider>
              <App />
            </HelmetProvider>
          </FormProvider>
        </BrowserRouter>
      {/* </PersistGate> */}
    </Provider>
  </React.StrictMode>
);

const root = ReactDOM.createRoot(rootElement);

if (rootElement.hasChildNodes()) {
  // Hydrate if there is pre-rendered content
  ReactDOM.hydrateRoot(rootElement, app);
} else {
  // Otherwise render normally
  root.render(app);
}

reportWebVitals();
